module.exports = __webpack_public_path__ + "img/boxed.682ec0eb.jpg";